import React from 'react';
import PropTypes from 'prop-types';
import { DefaultFontFamily } from 'app/common/react/components/common/FontFamily';

const styles = {
  container: {
    borderRadius: '100px',
    backgroundColor: '#fab904',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  textContainer: {
    padding: '20px 30px',
  },
  text: {
    fontFamily: DefaultFontFamily,
    fontSize: '18px',
    fontWeight: 'bold',
    fontStyle: 'normal',
    fontStretch: 'normal',
    MozOsxFontSmoothing: 'grayscale',
    WebkitFontSmoothing: 'antialiased',
    lineHeight: '1.11',
    letterSpacing: '-0.8px',
    textAlign: 'center',
    color: '#fff',
  },
};

function Toast(props) {
  const { error_title, error_subtitle } = props;

  return (
    <div style={styles.container}>
      <div style={styles.textContainer}>
        <div style={styles.text}>{error_title}</div>
        <div style={styles.text}>{error_subtitle}</div>
      </div>
    </div>
  );
}

Toast.propTypes = {
  error_title: PropTypes.string,
  error_subtitle: PropTypes.string,
};

export default Toast;
